// hooks/usePurchaseGame.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosClient from '@/lib/axiosClient';

interface PurchaseArgs {
  gameId: number;
  promocodeCode?: string;
}

interface PurchaseResponse {
  confirmationUrl?: string;
}

export function usePurchaseGame() {
  const queryClient = useQueryClient();

  return useMutation<PurchaseResponse, Error, PurchaseArgs>({
    mutationFn: async ({ gameId, promocodeCode }) => {
      const payload = promocodeCode ? { promocodeCode } : {};
      const res = await axiosClient.post<PurchaseResponse>(
        `/api/games/${gameId}/purchase`,
        payload,
      );
      return res.data;
    },

    onSuccess: (data, { gameId }, _context) => {
      if (data.confirmationUrl) {
        window.location.href = data.confirmationUrl;
        return;
      }

      queryClient.invalidateQueries({ queryKey: ['/api/games', gameId] });
      queryClient.invalidateQueries({ queryKey: ['/api/games', gameId, 'active-purchase'] });
    },
  });
}
